import * as React from "react";
import Typography from '@mui/material/Typography';
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { Autocomplete, Button, TextField } from '@mui/material';
import { Storefront } from '../models/StorefrontResponse';
import { AutocompleteUser } from '../hooks/useUsers';

interface Props {
    autocompleteUsers: AutocompleteUser[]
    storefront: Storefront
    userSelectedCallback(userID: string): void
    closeDialogCallback(): void
}

export default function UserList(props: Props) {
    const [customerID, setCustomerID] = React.useState<string | null>(null);

    const handleDialogClose = () => {
        props.closeDialogCallback()
    };

    const customerIDChanged = (event: React.SyntheticEvent<Element, Event>, value: AutocompleteUser | null) => {
        if (value) {
            setCustomerID(value.id);
            //props.userSelectedCallback(value.id);
        } else {
            setCustomerID(null);
        }
    };

    return (
        <Stack spacing={2} sx={{ p: 2 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography component="h2" variant="h6" color="primary" gutterBottom>
                    Customer Selection
                </Typography>
                <IconButton
                    size="small"
                    aria-label="close"
                    color="inherit"
                    onClick={() => handleDialogClose()}
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </Box>
            <Box sx={{ width: 600, marginTop: 2 }}>
                <Autocomplete
                    disablePortal
                    isOptionEqualToValue={(
                        option: AutocompleteUser,
                        value: AutocompleteUser
                    ) => option.id === value.id}
                    id="existingCustomer"
                    onChange={customerIDChanged}
                    options={props.autocompleteUsers}
                    size="small"
                    sx={{ width: 360 }}
                    renderInput={(params) => (
                        <TextField {...params} label="Customer Name" />

                    )}

                />

            </Box>
            <Button onClick={() => props.userSelectedCallback(customerID!)} variant="contained" color="primary" disabled={!customerID}>
                Select Customer
            </Button>
        </Stack>

    );
}
